import { IUser } from '@/data/models'
import { Getters } from '@/store/getters'
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { IStoreRootState } from '@/store'
import { Actions } from '@/store/actions'
import { AuthApiService } from '@/data/services'
import ability from '@/plugins/ability'
import _axios from '@/plugins/axios'

export interface IAuthModuleState {
  user: IUser | null;
  loading: boolean;
}

class AuthState implements IAuthModuleState {
  user: IUser | null = null
  loading: boolean = false
}

// initial state
const state = new AuthState()

// getters
const getters: GetterTree<IAuthModuleState, IStoreRootState> = {
  [Getters.IS_AUTHENTICATED]: (state: IAuthModuleState): boolean => !state.loading && state.user !== null,
  [Getters.AUTH_USER]: (state: IAuthModuleState): IUser | null => state.user,
  [Getters.AUTH_LOADING]: (state: IAuthModuleState): boolean => state.loading
}

const AuthMutationNames = {
  SET_AUTH_USER: 'SET_AUTH_USER',
  SET_AUTH_LOADING: 'SET_AUTH_LOADING'
}

// mutations
const mutations: MutationTree<IAuthModuleState> = {
  [AuthMutationNames.SET_AUTH_USER]: function(state: IAuthModuleState, value: IUser | null) {
    state.user = value
  },
  [AuthMutationNames.SET_AUTH_LOADING](state: IAuthModuleState, value: boolean) {
    state.loading = value
  }
}

// actions
const actions: ActionTree<IAuthModuleState, IStoreRootState> = {
  [Actions.AUTH_INIT]: async function({ commit, dispatch }) {
    try {
      commit(AuthMutationNames.SET_AUTH_LOADING, true)

      if (window.localStorage.getItem('ultrax_user_region')) {
        _axios.defaults.headers.common['X-Ultrax-User-Region'] = window.localStorage.getItem('ultrax_user_region')
      }

      const response = await AuthApiService.me()

      if (response.success && response.data) {
        dispatch(Actions.AUTH_LOGIN, response.data)
      }
    } catch (e) {
      // auth check false
    } finally {
      commit(AuthMutationNames.SET_AUTH_LOADING, false)
    }
  },
  [Actions.AUTH_LOGIN]: async function({ commit, dispatch }, user: IUser) {
    commit(AuthMutationNames.SET_AUTH_USER, user)

    if (user.region) {
      _axios.defaults.headers.common['X-Ultrax-User-Region'] = user.region
      window.localStorage.setItem('ultrax_user_region', user.region)
    }

    ability.update(user.permission_rules)

    if (!ability.can('manage-organisation', null) && !ability.can('manage-team', null)) {
      dispatch(Actions.AUTH_LOGOUT)
    }
  },
  [Actions.AUTH_LOGOUT]: function({ commit }) {
    commit(AuthMutationNames.SET_AUTH_USER, null)
  }
}

const authModule: Module<IAuthModuleState, IStoreRootState> = {
  state,
  getters,
  actions,
  mutations
}

export default authModule
